import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'store';

export const getSorting = (state: RootState) => state.sorting;

export const getLeadsSorting = createSelector(
  getSorting,
  (state) => state.leads,
);

export const getJobsSorting = createSelector(getSorting, (state) => state.jobs);

const sortingSelectors = {
  getSorting,
  getLeadsSorting,
  getJobsSorting,
};

export default sortingSelectors;
